import type { WebshopEditDetailsButton } from "./types/types";

export const createWebshopEditDetailsButton = (): WebshopEditDetailsButton => {
  const event: WebshopEditDetailsButton = {
    event: "Webshop Edit Details Button",
  };
  return event;
};
